import React, { useRef, useState, useEffect } from "react";

const TruncatedText = ({ text, className, maxLines = 1 }) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      // For single line, compare scrollWidth to clientWidth
      if (maxLines === 1) {
        setIsOverflowing(element.scrollWidth > element.clientWidth);
      } else {
        // For multi-line, compare scrollHeight to clientHeight
        setIsOverflowing(element.scrollHeight > element.clientHeight);
      }
    }
  }, [text, maxLines]);

  return (
    <div className={`truncated-text__wrapper ${className || ""}`}>
      <div ref={textRef} className="truncated-text__content">
        {text}
      </div>
      {isOverflowing && (
        <div className="tooltip tooltip--top-right tooltip--fast">
          <div className="tooltip__container">
            <div className="tooltip__container__subtitle">{text}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TruncatedText;
